import { Row } from 'antd';
import React from 'react';

import ColourScaleSelector from '../../../WidgetConfiguratorComponents/ColourScaleSelector';

export const ColourScaleSelectorFormGroup = (props) => {
    const { onChange, colourScale, colourCount } = props;

    return (
        <>
            <div style={{ gridColumn: 1 }}>
                <strong>Colour scale:</strong>
            </div>
            <div style={{ gridColumn: '2/5' }}>
                <Row style={{ width: '100%' }}>
                    <ColourScaleSelector onChange={onChange} value={colourScale} colourCount={colourCount} />
                </Row>
            </div>
        </>
    );
};
